export default {
    data: {
        A: "",
        B: "",
        C: "",
        D: "",
        E: [],
        F: "",
        G: "",
        H: [],
        J: "",
        K: [],
        L: ""
    },
    //type(Reg正则验证,Empty验证为空,MinMax验证数量区间)
    rule: {
        A: {
            type: "reg",
            rule: "^.{1,255}$",
            message: "请输入正确的表单A"
        },
        B: {
            type: "reg",
            rule: "^.{1,255}$",
            message: "请输入正确的表单B"
        },
        C: {
            type: "reg",
            rule: "^.{1,255}$",
            message: "请输入正确的表单C"
        },
        D: {
            type: "reg",
            rule: "^.{1,255}$",
            message: "请输入正确的表单D"
        },
        E: {
            type: "MinMaxStr",
            rule: "1-2",
            message: "请输入正确的表单E(1-2个)"
        },
        F: {
            type: "reg",
            rule: "^.{1,255}$",
            message: "请输入正确的表单F"
        },
        G: {
            type: "reg",
            rule: "^.{1,255}$",
            message: "请输入正确的表单G"
        },
        H: {
            type: "MinMax",
            rule: "1-2",
            message: "请输入正确的表单H(1-2个)"
        },
        J: {
            type: "reg",
            rule: "^.{1,255}$",
            message: "请输入正确的表单J"
        },
        K: {
            type: "MinMax",
            rule: "1-2",
            message: "请输入正确的表单K(1-2个)"
        },
        L: {
            type: "MinMaxStr",
            rule: "1-2",
            message: "请输入正确的表单L(1-2个)"
        }
    }
};